const sorter = (list, current) => {
  const newList = [...list]
  let oldList = [...list]
  try {
    return newList.map((p) => {
      const currentMatch = current[p.id]
      const random = rando(oldList, currentMatch, p)
      return {
        giver: p,
        recipient: oldList.splice(random, 1)[0]
      }
    })
  } catch (err) {
    console.log(err)
  }
}

function rando (list, currentMatch, p) {
  const random = Math.floor(Math.random() * list.length)
  const newM = list[random]
  if (newM.id === currentMatch || newM.family === p.family) {
    return rando(list, currentMatch, p)
  }
  return random
}

function matchmaker (list, current) {
  console.log('reordering...')
  return sorter(list, current)
}

export default matchmaker
